import { fetcher } from '@commenda/utils';
import { Country } from '@prisma/client';

export type TNameCheckContext = {
  jurisdiction?: string;
  entityType?: string;
  industry?: string;
  companyDescription?: string;
};

export type TNameCheckRequest = {
  name: string;
  country: Country;
  context?: TNameCheckContext;
};

export type TNameValidationIssue = {
  level: 'error' | 'warning' | 'info';
  rule:
    | 'Suffix'
    | 'Profanity'
    | 'RestrictedWord'
    | 'Government'
    | 'Similarity'
    | 'Length'
    | 'Charset'
    | 'Trademark'
    | 'Registry'
    | 'Custom';
  detail: string;
};

export type TNameValidationResponse = {
  normalizedName: string;
  coreKey: string;
  status: 'pass' | 'review' | 'fail';
  issues: TNameValidationIssue[];
  suggestions: string[];
};

async function checkName(body: TNameCheckRequest) {
  const res = await fetcher('name-check', { method: 'POST', body });
  if (!res.ok) {
    return { success: false, data: null };
  }
  const data = (await res.json()) as TNameValidationResponse;
  return { success: true, data };
}

export { checkName };
